<template>
    <div id="indexpage" v-title :data-title="title" style="height:100%;">
        <leftnav mkcode="D" itemcode="D-ZSHJ" :smScrennFull="true"></leftnav>
        <!-- 弹框 -->
        <div class="por" style="background-color: #041034;min-height:953px;height: 100vh;">
            <!-- 全屏开始 -->
            <i class="el-icon-full-screen swiper_fullscreen" @click="screen()"></i>
            <div class="index-swiper centerpage">
                <!-- <h2 class="title dataswipertitle" @mouseover="drawer = true" >{{userdata.cityText}}</span>{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2> -->
                <navIcn :title="title" :indexnum="6" navcode="SZGK" :fulltitle="true" :isShowYear="false"></navIcn>
                <div class="indexflex zhaoshangmap">
                    <div class="widthPC-95 margin-x-auto">
                        <div class="mt-2">
                            <h4 class="title display-inline-block mr-2">{{ cityText }}重点产业方向</h4>
                            <!-- 修改：el-option 的 value 改为整个 item，方便获取完整对象；并保留第一个 select 的 @change -->
                            <el-select v-model="notionClass1" placeholder="请选择" class="mr-1"
                                @change="changeClass(1, $event)">
                                <el-option v-for="item in notionClassList1" :key="item.value" :label="item.label"
                                    :value="item">
                                </el-option>
                            </el-select>
                            <!-- 修改：为第二个 select 添加 @change，并把 :value 改为 item -->
                            <el-select v-model="notionClass2" placeholder="请选择" class="mr-1"
                                @change="changeClass(2, $event)">
                                <el-option v-for="item in notionClassList2" :key="item.value" :label="item.label"
                                    :value="item">
                                </el-option>
                            </el-select>
                            <!-- 修改：为第三个 select 添加 @change，并把 :value 改为 item -->
                            <el-select v-model="notionClass3" placeholder="请选择" class="mr-1"
                                @change="changeClass(3, $event)">
                                <el-option v-for="item in notionClassList3" :key="item.value" :label="item.label"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="mt-2">
                            <el-row>
                                <el-col :span="10">
                                    <div class="hunan-map" id="hunanMap"></div>
                                </el-col>
                                <el-col :span='14'>
                                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
                                        <tr>
                                            <th>排名</th>
                                            <th>企业名称</th>
                                            <th>所属产业</th>
                                            <th>画像标签</th>
                                            <th>地区</th>
                                        </tr>
                                        <tr :key="i" v-for="(list, i) in enterpristlist">
                                            <td>{{ (page - 1) * pageSize + i + 1 }}</td>
                                            <td class="title"
                                                @click="routerlinkid('/enterprises', list.stockCode, curindex)">
                                                {{ list.title }}</td>
                                            <td class="conpanytags hastag">
                                                <span class="span-tag" :key="index"
                                                    v-for="(item, index) in list.notionlist" v-if="index<6"
                                                    @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name)">{{
                                                        item.name }}</span>
                                            </td>
                                            <td class="conpanytags notiontags">
                                                <span class="span-tag" :key="index"
                                                    v-for="(item, index) in list.taglist" v-if="index<6"
                                                    @click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name)">{{
                                                        item.name }}</span>
                                            </td>
                                            <td>{{ list.area }}</td>
                                        </tr>
                                    </table>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
                            <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                                v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import navIcn from "@/components/dataswiper-sass/HNZYB/navIcn.vue";

export default {
    components: { navIcn },
    name: 'zhaoshangditu',
    data() {
        return {
            isCollapse: false,
            isFullscreen: false,
            title: "湖南14个市州重点产业方向",
            notionClassList1: [],
            notionClass1: "",
            notionClassList2: [],
            notionClass2: "",
            notionClassList3: [],
            notionClass3: "",
            userdata: {},
            enterpristlist: [],
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 5, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            mapurl: 'map/province/hunan.json',
            public_tooltip: {
                trigger: 'axis',
                backgroundColor: 'rgba(255,255,255,0.9)',
                borderColor: '#ddd',
                borderWidth: '1',
                textStyle: {
                    color: '#000',
                    fontSize: 14,
                }
            },
            colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
            notioncode: '',
            fixassetsdata: [
                { name: "长沙市", value: 865.97,areaId:4301 },
                { name: "株洲市", value: 326.92,areaId:4302 },
                { name: "湘潭市", value: 130.42 ,areaId:4303 },
                { name: "岳阳市", value: 154.79 ,areaId:4306 },
                { name: "郴州市", value: 802.4 ,areaId:4310 },
                { name: "娄底市", value: 116.31 ,areaId:4313 },
                { name: "衡阳市", value: 116.28 ,areaId:4304 },
                { name: "常德市", value: 65.37 ,areaId:4307 },
                { name: "益阳市", value: 60.18 ,areaId:4309 },
                { name: "永州市", value: 44.01 ,areaId:4311 },
                { name: "怀化市", value: 35.95 ,areaId:4312 },
                { name: "邵阳市", value: 26.42 ,areaId:4305 },
                { name: "张家界市", value: 17.31 ,areaId:4308 },
                { name: "湘西土家族苗族自治州", value: 5.51, areaId:4331 },
            ],
            cityId: '',
            cityText: '湖南省',
        }
    },
    computed: {
    },
    created() {
        this.userdata = this.getuseriformation();
    },
    mounted() {
        this.getParams();
        this.mapGeo('hunanMap', this.fixassetsdata);
    },
    methods: {
        mapGeo(el, data) {
            var myChart = echarts.init(document.getElementById(el));
            var mapUrl = this.mapurl;
            let _this = this;
            console.log('产业用地数据', data);
            var tootlips = this.public_tooltip;
            $.getJSON(mapUrl, function (geoJson) {
                echarts.registerMap('taizhou', geoJson);
                myChart.hideLoading();
                var option = {
                    backgroundColor: 'rgba(0,0,0,0)',
                    title: {
                        top: 20,
                        text: '',
                        subtext: '',
                        x: 'center',
                        textStyle: {
                            color: '#fff',
                            fontWeight: 100,
                            fontSize: 14,
                        },
                    },
                    tooltip: {
                        alwaysShowContent: true,
                        show: true,
                        hoverAnimation: true,
                        trigger: 'item', //触发类型 散点图
                        enterable: true, //鼠标是否可进入提示框
                        transitionDuration: 1, //提示框移动动画过渡时间
                        triggerOn: 'click',
                        borderWidth: '1px',
                        borderRadius: '4',
                        borderColor: '#00B2AC',
                        backgroundColor: "rgba(0,0,0,.8)",
                        textStyle: {
                            color: '#fff'
                        },
                        formatter: function (parms) {
                            return "<h4 class='oh'><span class='fr'>" + parms.name + "</span></h4>";
                        }
                    },
                    geo: {
                        map: 'taizhou',
                        aspectScale: 0.8,
                        layoutCenter: ['50%', '50.5%'],
                        layoutSize: '100%',
                        silent: true,
                        roam: false,
                        z: 0,
                        itemStyle: {
                            normal: {
                                areaColor: 'rgba(0,0,0,.5)',
                                shadowColor: 'rgba(0, 0, 0, 1)',
                                shadowBlur: 0,
                                shadowOffsetX: 0,
                                shadowOffsetY: 1,
                                borderColor: 'rgba(0, 0, 0, 0.7)',
                                borderWidth: 0.5,
                            },
                            emphasis: {
                                areaColor: 'rgba(0,0,0,0)',
                                borderWidth: 1,
                                color: 'green',
                                label: {
                                    show: true,
                                },
                            },
                        },
                    },
                    series: [{
                        type: 'map',
                        zoom: 1.1,
                        // roam: false,
                        map: 'taizhou',
                        roam: false,
                        data: data,
                        label: {
                            normal: {
                                show: true,
                                textStyle: {
                                    color: '#fff',
                                },
                            },
                            emphasis: {
                                textStyle: {
                                    color: '#fff',
                                },
                            },
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#6185be',
                                borderWidth: 1,
                                // areaColor: {
                                // 	image: mappng,
                                // 	repeat: 'repeat',
                                // },
                                areaColor: "#045c99",
                                shadowColor: '#96aece',
                                shadowBlur: 0,
                                shadowOffsetX: 0,
                                shadowOffsetY: 1,
                            },
                            emphasis: {
                                // areaColor: {
                                // 	image: '#f60',
                                // 	repeat: 'repeat',
                                // },
                                areaColor: "#023e64",
                                borderColor: '#ccc',
                                borderWidth: 1,
                                shadowColor: '#96aece',
                                shadowBlur: 10,
                                shadowOffsetX: 2,
                                shadowOffsetY: 1,
                                label: {
                                    show: true,
                                },
                            },
                        },

                    },

                    ],
                };
                myChart.setOption(option);
            });
            var hourIndex = 0;
            var fhourTime = null;
            // fhourTime = setInterval(function () {
            //     myChart.dispatchAction({
            //         type: "downplay",
            //         seriesIndex: 0,

            //     });
            //     myChart.dispatchAction({
            //         type: "highlight",
            //         seriesIndex: 0,
            //         dataIndex: hourIndex
            //     });
            //     myChart.dispatchAction({
            //         type: "showTip",
            //         seriesIndex: 0,
            //         dataIndex: hourIndex
            //     });
            //     hourIndex++;
            //     if (hourIndex > data.length) {
            //         hourIndex = 0;
            //     }
            // }, 3000);
            //鼠标移入停止轮播
            myChart.on("mousemove", function (e) {
                clearInterval(fhourTime)
                myChart.dispatchAction({
                    type: "downplay",
                    seriesIndex: 0,
                });
                myChart.dispatchAction({
                    type: "highlight",
                    seriesIndex: 0,
                    dataIndex: e.dataIndex
                });
                myChart.dispatchAction({
                    type: "showTip",
                    seriesIndex: 0,
                    dataIndex: e.dataIndex
                });
            })
            //鼠标移出恢复轮播
            // myChart.on("mouseout", function () {
            //     fhourTime = setInterval(function () {
            //         myChart.dispatchAction({
            //             type: "downplay",
            //             seriesIndex: 0,

            //         });
            //         myChart.dispatchAction({
            //             type: "highlight",
            //             seriesIndex: 0,
            //             dataIndex: hourIndex
            //         });
            //         myChart.dispatchAction({
            //             type: "showTip",
            //             seriesIndex: 0,
            //             dataIndex: hourIndex
            //         });
            //         hourIndex++;
            //         if (hourIndex > data.length) {
            //             hourIndex = 0;
            //         }
            //     }, 3000);
            // })
            myChart.on('click', function (params) {
                console.log('点击了地图', params);
                _this.cityId = params.data.areaId;
                _this.cityText = params.name;
                _this.getParams();
            });
        },
        pageHandler: function (page) {
            this.ajaxsearchcompany(page, 'sort', 'search');
        },
        // 修改：changeClass 现在接收完整的 selectedItem（整个对象）
        changeClass(step, selectedItem) {
            console.log('changeClass', step, selectedItem);
            if (!selectedItem) {
                return;
            }
            if (step == 1) {
                // selectedItem 可能包含 children 数组
                const firstChild = Array.isArray(selectedItem.children) && selectedItem.children.length ? selectedItem.children[0] : null;
                this.notioncode = firstChild ? (firstChild.value || firstChild.code || '') : (selectedItem.value || selectedItem.code || '');
                this.notionClassList2 = Array.isArray(selectedItem.children) ? selectedItem.children : [];
                this.notionClassList3 = firstChild && Array.isArray(firstChild.children) ? firstChild.children.slice() : [];
                // 添加“全部”选项（根据原逻辑）
                // this.notionClassList3.push({ value: '', label: '全部' });
                this.notionClass1 = selectedItem.label || selectedItem.name || '';
                this.notionClass2 = firstChild ? (firstChild.label || firstChild.name || '') : '';
                this.notionClass3 = '';
            } else if (step == 2) {
                const child = selectedItem;
                this.notionClass3 = Array.isArray(child.children) ? child.children : [];
                this.notionClass2 = child.label || child.name || '';
                this.notionClassList3 = Array.isArray(selectedItem.children) ? selectedItem.children : [];
                this.notionClass3 = '';
                this.notioncode = child.value || child.code || '';
            } else if (step == 3) {
                this.notionClass3 = selectedItem.label || selectedItem.name || '';
                this.notioncode = selectedItem.value || selectedItem.code || '';
            }
            console.log('最终选择的notioncode', this.notioncode, '---', this.notionClass1, '---', this.notionClass2, '---', this.notionClass3);
            this.ajaxsearchcompany();
        },
        //获取概念
        getParams() {
            let ajaxurl = this.$api.cyl.usercenter.investNotion()+'?city='+this.cityId;
            let _this = this;
            this.bus.$emit('loading', true);
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                console.log('获取概念', res.data);
                if (res.data.success) {
                    var list = res.data.list;
                    list = _this.transformData(list);
                    for (let i = 0; i < list.length; i++) {
                        list[i].value = 'U' + list[i].name;
                    }
                    _this.notionClassList1 = list;

                    console.log('获取概念list', _this.notionClassList1);
                    _this.changeClass(1, _this.notionClassList1[0]);
                }
            this.bus.$emit('loading', false);

            }).catch(function (error) {
                // 请求失败处理
                console.log(error);
                // _this.$message({

                // })
            });
        },
        //处理简易版重点产业数据
        transformData(obj) {
            if (Array.isArray(obj)) {
                // 如果是数组，递归处理每一项
                return obj.map(item => this.transformData(item));
            } else if (typeof obj === 'object' && obj !== null) {
                // 如果是对象
                if ('name' in obj) {
                    obj.label = obj.name;  // 添加或覆盖 label 字段
                }
                if ('code' in obj) {
                    obj.value = obj.code;  // 添加或覆盖 value 字段
                    obj.relatedCode = obj.code;
                    obj.iskeyNotion = true;
                }

                // 递归处理子对象
                for (let key in obj) {
                    if (typeof obj[key] === 'object' && obj[key] !== null) {
                        obj[key] = this.transformData(obj[key]);
                    }
                }

                return obj; // 返回修改后的对象
            }

            // 如果是其他类型，直接返回
            return obj;
        },
        ajaxsearchcompany(pages) {
            this.bus.$emit('loading', true);
            this.page = pages ? pages : 1;
            let _this = this;
            let pCity = this.cityId ? '&province=43&city='+this.cityId : '&province=43';
            let ajaxurl = this.$api.cyl.investclue.keyIndustry() + '?page=' + this.page + '&pageSize=' + this.pageSize + '&notion=' + this.notioncode+pCity;
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                console.log('获取企业列表', res.data);
                if (res.data.success) {
                    var dataenterlist = res.data.list;
                    for (var i = 0; i < res.data.list.length; i++) {
                        dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[
                            i].notionCode, 'notionsort');
                        dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i]
                            .tagCode);
                    }
                    _this.enterpristlist = dataenterlist;
                    _this.totalPage = res.data.totalPage;
                    _this.total = res.data.totalRecord;
                    _this.haspage = res.data.list.length == res.data.pageSize;
                }
                _this.bus.$emit('loading', false);
            });
        },
    }
}
</script>

<style scoped="scoped" lang="scss">
@import url('/src/css/dataswiper.css');

#hunanMap {
    width: 100%;
    height: 675px;
    // border: 1px solid #fff;
}

#app {
    background-color: #041034;
}

.indexflex {
    color: #fff;
}

::v-deep {
    .centerpage1 {
        width: auto;
        height: auto;
        margin:  0 auto; 
    }
    .company_pagelist{
        padding: 0;
    }
    .zpagenav {
        float: right;
        margin-top: 20px;

        .jump {
            color: #fff;
        }

        .jumppage,
        .jumppage_btn {
            background-color: #00356a;
            color: #fff;
        }

        ul {
            li {
                color: #fff;
                cursor: pointer;
                background-color: #00356a;
                border: 1px solid #00356a;

                &:hover {
                    color: #59ccc2;
                }

                &.active {
                    background-color: #59ccc2;
                    color: #041034;
                }
            }
        }
    }

    .el-popper.el-select-dropdown {
        background-color: rgba(4, 16, 52, 0.5);
        color: #fff;
    }

    .el-select {
        .el-input__inner {
            background-color: rgba(4, 16, 52, 0.5);
            color: #fff;
        }
    }
}

.enterprise_table {
    width: 100%;
    border-collapse: collapse;

    th {
        background-color: #00356a;
    }

    th,
    td {
        border: 1px solid #0f2a57;
        // padding:8px 12px;
        text-align: center;
    }

    tr {
        &:hover {
            color: #fff;
            background-color: #0f2a57;
        }
    }

    .title {
        color: #fff;
        cursor: pointer;

        &:hover {
            color: #fff;

        }
    }

    .collectfont1 {
        span {
            color: #fff
        }
    }

    .conpanytags {
        .span-tag {
            display: inline-block;
            background-color: #18485B;
            color: #fff;
            padding: 2px 6px;
            margin: 2px;
            border-radius: 4px;
            cursor: pointer;
        }
    }
}
</style>
